/* mm-ziel2.js — Magic Milk
 *
 * DUPLIKAT von mm-ziel.js in einer hochwertigeren Fassung (Mert, 16.08.2026:
 * "An sich gefaellt mir alles ... aber ich moechte, dass es hochwertiger
 * aussieht wie hier in diesem Code. Mach erst ein Duplikat direkt da drueber,
 * damit ich es vergleichen kann.").
 *
 * Es steht DIREKT UEBER dem Original, beide laufen gleichzeitig. Sobald Mert
 * sich entschieden hat, fliegt eines der beiden Skripte aus theme.liquid.
 *
 * Unveraendert uebernommen, weil Mert das ausdruecklich behalten wollte:
 * die Details je Produkt, "Zum Produkt", Wischen nach links und rechts, der
 * Fortschrittsbalken, das automatische Weiterschalten, die drei Reiter und
 * das Badge in der Knopf-Optik.
 *
 * Anders ist nur die Optik, uebernommen aus Merts React-Vorlage
 * (motion/react LayoutSwitcher):
 *   - Feder statt Ausklang: stiffness 350, damping 30, mass 1 ist als
 *     linear()-Kurve nachgerechnet (siehe FEDER unten), inklusive des
 *     kleinen Ueberschwingers. Fallback davor ist eine cubic-bezier, falls
 *     der Browser linear() nicht kennt.
 *   - Reiter als schmale Pille (w-fit) mit gleitender Fuellung, nicht mehr
 *     ueber die volle Breite.
 *   - Haarlinie zwischen Ueberschrift und Reitern (h-px bg-border).
 *   - Grosse weiche Radien (26 px Karte, 20 px Bild) statt 13/18.
 *   - Wechsel mit Unschaerfe und Skalierung (blur 4px, scale .97).
 *   - Der Zaehler sitzt als kleine Pille neben dem Titel, wie das "#209"
 *     in der Vorlage. Der Balken bleibt, nur duenner (2 statt 3 px).
 *
 * KEINE KI-Optik: keine Verlaeufe, kein Leuchten, keine schwebenden Karten.
 */
(function () {
  if (!(typeof window.mmStartseite === 'function' ? window.mmStartseite() : window.location.pathname === '/')) return;

  var K = 'cubic-bezier(.22,.61,.36,1)';
  /* Mert 16.08.: "mach das in einer passenden grün farbe".
     #9CCC3C ist das helle Flächengrün der ZeroTermo-Packung, aus den
     echten Fotos gemessen. Auf dem dunklen Sektionsgrund #151013 hat es
     Kontrast 10:1. Das dunkle Packungsgrün #55711C läge bei 3,4 und wäre
     hier zu schwach — deshalb bewusst der helle Ton, nicht der von den
     Produktseiten. */
  var GRUEN = '#9CCC3C';
  var TAKT = 3600;               // Standzeit je Bild in Millisekunden
  var CDN = 'https://cdn.shopify.com/s/files/1/0958/0465/3955/files/';

  var ruhig = false;
  try { ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* 16.08. Mert: "Die Beschreibung ist immer gleich. Das darf nicht immer
     gleich sein, bei jedem anders." Vorher stand unter jedem Bild derselbe
     Satz, weil er aus dem REITER kam statt aus dem Produkt.

     Die Shopify-Beschreibungen taugen als Teaser NICHT: alle elf fangen mit
     demselben Pflichttext an ("Dieses Produkt ist ein Nahrungsergaenzungs-
     mittel und kein Arzneimittel ...") und enthalten sonst nur Zutaten- und
     Allergenlisten. Nachgesehen am 16.08. ueber products.json.

     Stattdessen ein Satz je Produkt, gebaut aus dem, was am Titel und an der
     Variante eindeutig ist: Sorte, Set-Groesse, Produktreihe. Keine Wirkungs-
     oder Naehrwertaussagen - die waeren bei Nahrungsergaenzung heikel und
     TikTok beanstandet sie auf der Zielseite.
     REIHENFOLGE ZAEHLT: Sets zuerst, sonst greift bei "(2er SET) ... -
     Strawberry" die Einzelregel fuer Erdbeere. */
  /* 17.08. Mert: "Strawberry ist die bessere Version von Neutral, die neuere
     und die bessere Premium-Formel ... mach es eben marketingtechnisch fuer
     jedes Produkt, damit die Leute die teuren kaufen."

     Jeder Satz sagt jetzt, auf WELCHER STUFE das Produkt steht - Einstieg,
     Premium, oberste Stufe. Das zieht nach oben, ohne eine Wirkung zu
     versprechen: "wirkt besser" oder "bessere Ergebnisse" waere bei einem
     Nahrungsergaenzungsmittel eine gesundheitsbezogene Angabe und muesste
     nach EU-Verordnung 1924/2006 zugelassen sein. Positionierung darf man
     behaupten, Wirkung nicht. */
  var SATZ = [
    [/magic.?fruit|florea.*fruit/i,
       'Die Premium-Reihe von Florea. Fruchtig, ein Beutel morgens vor dem Essen.'],
    [/zero.?termo|pro.?milk|nuss|creamy|nutty/i,
       'Premium-Linie Pro Milk ZeroTermo. Nussig und cremig statt neutral.'],
    [/kapsel/i,
       'Kapseln statt Pulver. Nichts anrühren, geht auch unterwegs.'],
    [/ananas/i,
       'Die Premium-Fassung als Tee. Geschmack Ananas.'],
    [/lemon|zitrone/i,
       'IRON als Tee, Geschmack Zitrone.'],
    [/cherry|kirsch/i,
       'IRON als Tee, Geschmack Kirsche.'],
    [/coffee.*plus|plus.*coffee/i,
       'Die PLUS-Fassung der Kaffee-Linie. Eine Stufe über dem Standard.'],
    [/coffee.*iron|iron.*coffee/i,
       'IRON, die Premium-Stufe der Kaffee-Linie.'],
    [/magic.?coffee/i,
       'Die Special-Fassung von Florea — oberste Stufe der Kaffee-Reihe.'],
    [/coffee|kaffee/i,
       'Der Einstieg in die Kaffee-Linie. Ein Beutel am Tag.'],
    [/erdbeer|strawberry/i,
       'Die neuere Premium-Formel: alles aus Neutral, dazu Erdbeere.'],
    [/neutral|standard|magic.?milk|for.?x5/i,
       'Der Klassiker. Zehn pflanzliche Zutaten, neutral — mischt sich in alles.']
  ];


  /* 17.08. Mert: "bei den Sets machst du immer einen Spartext ... zwei
     Packungen, neutral, ein Stick am Tag - das reicht nicht. Du musst die
     Leute ein bisschen so ziehen."

     ACHTUNG, nachgerechnet am 17.08.: gegenueber Einzelkauf sparen die Sets
     fast nichts - das 2er Magic Milk 0,99 EUR (1 %), die anderen 2 bis 4 %.
     "Doppelt sparen" waere also schlicht falsch. Was stimmt und trotzdem
     zieht, ist der Streichpreis, den der Shop ohnehin ueberall anzeigt
     (25 bis 34 %). Der Prozentwert wird deshalb bei JEDEM Laden frisch aus
     compare_at_price gerechnet und nie fest eingetragen - sonst steht hier
     irgendwann eine Zahl, die es im Warenkorb nicht mehr gibt.

     Der zweite Zug ist die Menge: 30 Sachets je Packung (steht so auf Merts
     eigenem Motiv "DREISSIG PORTIONEN, EIN MONAT"), also 60/90/120 Sticks
     und Vorrat fuer zwei, drei oder vier Monate. */
  var ZAHLWORT = { 2: 'Zwei', 3: 'Drei', 4: 'Vier' };
  var MONATE   = { 2: 'zwei', 3: 'drei', 4: 'vier' };

  function setSatz(titel, n) {
    var gemischt = /standard\s*&\s*strawberry|gemischt/i.test(titel);
    var erdbeere = /erdbeer|strawberry/i.test(titel);
    if (gemischt) {
      return 'Einmal Neutral, einmal Erdbeere. 60 Sticks — beide Sorten ' +
             'testen, ohne zweimal zu kaufen.';
    }
    var sorte = erdbeere ? 'Premium-Formel Erdbeere' : 'Neutral';
    var schluss = n >= 4
      ? 'Der größte Vorrat: vier Monate am Stück.'
      : (n === 3 ? 'Drei Monate ohne Nachbestellen.'
                 : 'Zwei Monate durchziehen statt nach vier Wochen nachlegen.');
    return (ZAHLWORT[n] || n) + ' Packungen ' + sorte + ', ' + (n * 30) +
           ' Sticks. ' + schluss;
  }

  /* Rabatt kommt aus dem Streichpreis und wird bei JEDEM Laden neu gerechnet.
     Nie fest eintragen - sonst steht hier irgendwann eine Zahl, die es im
     Warenkorb nicht mehr gibt. */
  function rabattVon(p) {
    var v = ((p && p.variants) || [])[0] || {};
    var preis = parseFloat(v.price), vorher = parseFloat(v.compare_at_price);
    return (vorher && preis && vorher > preis)
      ? Math.round((1 - preis / vorher) * 100) : 0;
  }

  /* 17.08. Mert: "Kannst auch hier irgendwo eine Leiste machen mit
     Geschmack, Erdbeeren, Nuss, neutral und so weiter, sodass man switchen
     kann." Die Leiste baut sich aus dem, was im jeweiligen Reiter wirklich
     drin ist - unter Zunehmen also Neutral/Erdbeere/Nuss/Fruchtig, unter
     Abnehmen Kaffee/Tee/Kapseln. Bleibt nur eine Sorte uebrig, wird die
     Leiste ausgeblendet; bei "Anwendung" gibt es gar keine Sorten.
     REIHENFOLGE ZAEHLT wie ueberall: Magic Fruit vor Erdbeere. */
  var GESCHMACK = [
    [/magic.?fruit|florea.*fruit|ananas|lemon|zitrone|cherry|kirsch/i, 'Fruchtig'],
    [/zero.?termo|pro.?milk|nuss|creamy|nutty/i,                       'Nuss'],
    [/kapsel/i,                                                        'Kapseln'],
    [/coffee|kaffee/i,                                                 'Kaffee'],
    [/tea|tee/i,                                                       'Tee'],
    [/erdbeer|strawberry/i,                                            'Erdbeere'],
    [/./,                                                              'Neutral']
  ];

  function geschmackVon(titel) {
    for (var i = 0; i < GESCHMACK.length; i++) {
      if (GESCHMACK[i][0].test(titel || '')) return GESCHMACK[i][1];
    }
    return 'Neutral';
  }

  function beschreibung(p) {
    var titel = (p && p.title) || '';
    var v = ((p && p.variants) || [])[0] || {};

    var m = titel.match(/\((\d)\s*er\s*SET\)/i);
    if (m) return setSatz(titel, parseInt(m[1], 10));

    var q = titel + ' ' + (v.title || '');
    for (var i = 0; i < SATZ.length; i++) {
      if (SATZ[i][0].test(q)) return SATZ[i][1];
    }
    return null;                    // faellt auf den Reiter-Satz zurueck
  }


  /* Produktfarbe je Artikel (Mert, 17.08.2026: "bei Erdbeer machst du rot,
     bei Nuss machst du gruen, also alles dann anpassen ... immer farblich
     anpassen nach jedem Switch").

     Herkunft: Verpackung bzw. das echte Produktfoto, danach so weit
     aufgehellt, dass der Kontrast auf #151013 mindestens 4.6 betraegt -
     sonst waere der 11-px-Zaehler nicht lesbar. Zwei alte Notizen waren
     falsch und sind hier korrigiert: #55711C hat 3.4 (nicht 5.58) und
     #DF611D hat 5.3 (nicht 3.58), beide am 17.08. nachgerechnet.

     REIHENFOLGE ZAEHLT: "Magic Fruit Premium - Strawberry" enthaelt
     "Strawberry", muss aber die Florea-Farbe bekommen. */
  var PRODUKTFARBE = [
    /* Gemischte Sets zuerst: "(2er SET) Standard & Strawberry" enthaelt
       "Strawberry" und bekaeme sonst das Rosa. Mert am 17.08.: "Bei Standard
       und Strawberry, also gemixt, machst du gar keine Farbe. Einfach weiss."
       Genommen wird das Marken-Weiss #F3E9EC, dieselbe Farbe wie der
       Fliesstext - Kontrast 15.6, hoechster Wert der ganzen Tabelle. */
    [/standard\s*&\s*strawberry|gemischt/i,       '#F3E9EC'],  /* gemischt: weiss    15.6 */
    [/magic.?fruit|florea/i,                      '#D74F66'],  /* Pinkrot Florea      4.7 */
    [/zero.?termo|pro.?milk|nuss|creamy|nutty/i,  '#698B22'],  /* Packungsgruen       4.8 */
    [/kapsel/i,                                   '#C85D62'],  /* Rot vom Glasetikett 4.7 */
    [/ananas/i,                                   '#D28820'],  /* Ananas-Box          6.5 */
    [/lemon|zitrone/i,                            '#D8B21A'],  /* Zitronengelb        9.2 */
    [/cherry|kirsch/i,                            '#DE4756'],  /* Kirschrot           4.6 */
    [/magic.?coffee/i,                            '#D9700B'],  /* Florea-Orange       5.6 */
    [/coffee|kaffee/i,                            '#B07A2A'],  /* Kaffee-Gold         5.1 */
    [/erdbeer|strawberry/i,                       '#EA597B'],  /* Strawberry          5.6 */
    [/./,                                         '#DF611D']   /* FOR-X5-Orange       5.3 */
  ];

  function produktfarbe(titel) {
    for (var i = 0; i < PRODUKTFARBE.length; i++) {
      if (PRODUKTFARBE[i][0].test(titel || '')) return PRODUKTFARBE[i][1];
    }
    return GRUEN;
  }

  var REITER = [
    { name: 'Zunehmen',  quelle: '/collections/zunehmen/products.json?limit=12',
      text: 'Magic Milk FOR X5 — ein Stick am Tag, in Wasser eingerührt, vor der Mahlzeit.' },
    { name: 'Abnehmen',  quelle: '/collections/abnehmen/products.json?limit=12',
      text: 'Slim Weight Control — Kaffee, Tee und Kapseln aus derselben Reihe.' },
    { name: 'Anwendung', quelle: null,
      text: 'Ein Sachet aus der Packung nehmen, in 200–250 ml Wasser einrühren, ' +
            'vor einer Mahlzeit trinken. Eine Box reicht 30 Tage.',
      bilder: [
        { bild: CDN + 'mm-box-ablauf.jpg',  titel: 'So einfach geht es',
          text: 'Sachet aufreißen, in 200–250 ml Wasser einrühren, vor der Mahlzeit trinken.',
          ziel: '/products/magic-milk-for-x5' },
        { bild: CDN + 'mm-box-zutaten.jpg', titel: 'Zehn Zutaten',
          text: 'Zehn pflanzliche Zutaten, darunter Ingwer, Kamille und Zimt.',
          ziel: '/products/magic-milk-for-x5' },
        { bild: CDN + 'mm-box-vorrat.jpg',  titel: 'Vorrat für 30 Tage',
          text: 'Dreißig einzelne Sachets in der Box — eines pro Tag.',
          ziel: '/products/magic-milk-for-x5' },
        { bild: CDN + 'mm-box-siegel.jpg',  titel: 'Vier Hologramm-Siegel',
          text: 'Vier Siegel auf der Packung, damit du das Original erkennst.',
          ziel: '/products/magic-milk-for-x5' }
      ] }
  ];

  var FEDER = 'linear(0.0000,0.0572,0.1867,0.3424,0.4963,0.6332,0.7465,0.8350,0.9008,0.9472,0.9782,0.9974,1.0083,1.0134,1.0148,1.0140,1.0121,1.0098,1.0075,1.0055,1.0038,1.0025,1.0015,1.0008,1.0003,1.0000,0.9999)';
  var WEICH = 'cubic-bezier(.22,.61,.36,1)';   /* Rueckfall ohne linear() */

  var css = [
    '#mmPro{flex:0 0 auto;align-self:stretch;width:100%;max-width:100%;min-width:0;',
    'box-sizing:border-box;margin:0;padding:clamp(56px,7vw,96px) 0;',
    'background:#151013;color:#F3E9EC;position:relative;overflow:clip}',
    '#mmPro *{box-sizing:border-box}',
    '#mmPro .mmPInnen{max-width:1000px;margin:0 auto;padding:0 clamp(16px,3vw,24px)}',

    '#mmPro .mmPAuge{font-size:.72rem;letter-spacing:.2em;text-transform:uppercase;',
    'color:' + GRUEN + ';margin:0 0 10px;font-weight:600}',
    '#mmPro h2{font-family:"Barlow Condensed",sans-serif;text-transform:uppercase;',
    'font-size:clamp(1.9rem,6vw,3rem);line-height:1;letter-spacing:0;',
    'margin:0;font-weight:800;color:#F3E9EC}',

    /* Haarlinie wie das h-px bg-border in der Vorlage */
    '#mmPro .mmPTrenner{height:1px;background:rgba(243,233,236,.10);margin:20px 0}',

    /* Reiter: schmale Pille, nur so breit wie noetig */
    /* 17.08. Mert: "Macht das hier genauso?" - Vorlage ist die dunkle
       Segmentleiste aus der Claude-Code-Oberflaeche (Startseite | Code).
       Das ersetzt das Glas von vorhin: kein Hintergrund-Weichzeichner, kein
       Innenschatten-Stapel, keine gruene Fuellung mehr. Stattdessen eine
       ruhige dunkle Wanne, in der ein etwas hellerer Chip mit Haarlinie
       sitzt. Der Chip gleitet weiter mit der Feder - die Bewegung war nie
       das Problem, nur die Optik. */
    '#mmPro .mmPLeiste{position:relative;display:inline-flex;padding:5px;gap:0;',
    'background:rgba(243,233,236,.05);border:1px solid rgba(243,233,236,.06);',
    'border-radius:14px;max-width:100%;overflow:hidden}',
    '#mmPro .mmPGleiter{position:absolute;top:5px;left:0;border-radius:10px;',
    'background:#2A2126;border:1px solid rgba(243,233,236,.10);',
    'box-sizing:border-box;pointer-events:none;',
    'transition:transform .5s ' + WEICH + ',width .5s ' + WEICH + ',height .5s ' + WEICH + ';',
    'transition-timing-function:' + FEDER + '}',
    '#mmPro .mmPKnopf{position:relative;z-index:1;border:0;background:transparent;',
    'padding:9px clamp(12px,3.4vw,20px);border-radius:10px;cursor:pointer;',
    'font-size:clamp(.78rem,3.4vw,.9rem);font-weight:500;line-height:1;',
    'white-space:nowrap;color:rgba(243,233,236,.5);',
    '-webkit-tap-highlight-color:transparent;transition:color .25s ease}',
    '#mmPro .mmPKnopf[aria-selected="true"]{color:#F3E9EC;font-weight:600}',
    '#mmPro .mmPKnopf:focus-visible{outline:2px solid ' + GRUEN + ';outline-offset:3px}',

    /* Sortenleiste: kleiner als die Reiter, gleiche Handschrift. Sie darf
       umbrechen - unter "Abnehmen" stehen bis zu drei Sorten, auf schmalen
       Geraeten passt das sonst nicht. */
    /* EINE Zeile statt Umbruch. Fuenf Knoepfe mit Bild passen auf 375 px
       nicht nebeneinander; vorher brachen sie auf zwei Zeilen um und das sah
       nach Zufall aus (Mert: "sieht ein bisschen zu durcheinander aus").
       Jetzt laufen sie waagerecht weiter und lassen sich schieben - die
       Bildleiste bleibt eine ruhige Linie. Der Rollbalken ist ausgeblendet,
       das angeschnittene letzte Bild zeigt, dass es weitergeht. */
    '#mmPro .mmPSorten{display:flex;flex-wrap:nowrap;gap:6px;margin-top:12px;',
    'overflow-x:auto;overflow-y:hidden;scrollbar-width:none;',
    '-webkit-overflow-scrolling:touch;padding-bottom:2px}',
    '#mmPro .mmPSorten::-webkit-scrollbar{display:none}',
    '#mmPro .mmPSorten[hidden]{display:none}',
    '#mmPro .mmPSorte{flex:none;display:inline-flex;align-items:center;gap:7px;',
    'border:1px solid rgba(243,233,236,.06);',
    'background:rgba(243,233,236,.05);color:rgba(243,233,236,.5);',
    'padding:5px 13px 5px 5px;border-radius:999px;cursor:pointer;',
    'font-size:.76rem;font-weight:500;line-height:1;white-space:nowrap;',
    '-webkit-tap-highlight-color:transparent;',
    'transition:color .25s ease,background .25s ease,border-color .25s ease}',
    '#mmPro .mmPSorte:first-child{padding-left:13px}',   /* "Alle" hat kein Bild */
    '#mmPro .mmPSorteBild{width:22px;height:22px;border-radius:50%;',
    'object-fit:cover;display:block;flex:none;',
    'background:rgba(243,233,236,.06)}',
    '#mmPro .mmPSorte[aria-selected="true"]{background:#2A2126;color:#F3E9EC;',
    'border-color:rgba(243,233,236,.10);font-weight:600}',
    '#mmPro .mmPSorte:focus-visible{outline:2px solid ' + GRUEN + ';outline-offset:2px}',

    /* Karte */
    '#mmPro .mmPBuehne{margin-top:20px}',   /* gleicher Abstand wie oben */
    /* 17.08. Mert: "ich will genauso vom Design bei der Wahl und der Abstand
       zur Collection genauso." Die Karte traegt deshalb exakt dieselbe
       Flaeche wie die Reiterleiste - durchscheinende Wanne
       rgba(243,233,236,.05) mit derselben Haarlinie .06 - statt des satten
       Blocks #1A1418 mit staerkerem Rahmen. Radius bleibt groesser, die
       Karte ist ja auch ein Vielfaches groesser; dafuer sitzt der Radius des
       Bildes jetzt richtig verschachtelt (26 aussen minus 14 Polster = 12,
       vorher 20 und dadurch ausgebeult). */
    '#mmPro .mmPBild,#mmPro .mmPText{display:block;text-decoration:none;',
    'color:inherit}',
    '#mmPro .mmPBlatt{display:block;text-decoration:none;color:inherit;',
    'border:1px solid rgba(243,233,236,.06);border-radius:26px;',
    'background:rgba(243,233,236,.05);',
    'padding:14px;touch-action:pan-y;',
    'transition:opacity .42s ' + WEICH + ',transform .42s ' + WEICH + ',filter .42s ' + WEICH + ';',
    'transition-timing-function:' + FEDER + '}',
    '#mmPro .mmPBlatt:not(.da){opacity:0;transform:scale(.97);filter:blur(4px)}',
    '#mmPro .mmPBildBox{position:relative;display:block;border-radius:12px;',
    'overflow:hidden;border:1px solid rgba(243,233,236,.06)}',
    '#mmPro .mmPBlatt img{display:block;width:100%;aspect-ratio:4/3;',
    'height:auto;object-fit:cover}',

    /* Titelzeile mit Zaehler-Pille rechts, wie das "#209" in der Vorlage */
    '#mmPro .mmPZeile{display:flex;align-items:flex-start;justify-content:space-between;',
    'gap:12px;margin:14px 3px 0}',
    /* 17.08. Mert: "Ich will die Ueberschrift in genau so einer Groesse. Du
       hast die Groesse viel zu klein gemacht." Vorher 1.05rem/4.4vw, also
       16,8 px auf 375 px - die Beschreibung daneben hat 14,4 px, der Titel
       stand damit kaum ueber dem Fliesstext. Jetzt 20,3 px auf 375 px, dazu
       Schnitt 800 und Laufweite wie in der unteren Sektion. Der Titel
       fuehrt damit klar. */
    '#mmPro h3{margin:0;min-width:0;font-family:"Barlow Condensed",sans-serif;',
    'text-transform:uppercase;font-size:clamp(1.3rem,5.4vw,1.75rem);',
    'line-height:1.08;letter-spacing:-.01em;font-weight:800;color:#fff}',
    '#mmPro .mmPZahl{flex:none;display:inline-flex;align-items:center;',
    'padding:4px 9px;border-radius:999px;',
    'background:rgba(156,204,60,.12);',
    'background:color-mix(in srgb, var(--pf,' + GRUEN + ') 14%, transparent);',
    'transition:background .45s ease;',
    'color:rgba(243,233,236,.5);font-size:.66rem;font-weight:700;line-height:1;',
    'font-variant-numeric:tabular-nums}',
    '#mmPro .mmPZahl b{color:var(--pf,' + GRUEN + ');font-weight:700;',
    'transition:color .45s ease}',
    '#mmPro .mmPBlatt p{margin:7px 3px 0;font-size:.9rem;line-height:1.5;',
    'color:rgba(243,233,236,.55)}',
    '#mmPro .mmPMehr{display:inline-block;margin:13px 3px 2px;',
    'color:var(--pf,' + GRUEN + ');transition:color .45s ease;',
    'font-size:.88rem;font-weight:600}',

    /* Badge unveraendert: Vorlage ist der Knopf "JETZT VORBESTELLEN" */
    '#mmPro .mmPBadge{position:absolute;top:12px;right:12px;z-index:2;',
    'font-family:Poppins,sans-serif;font-size:14px;font-weight:600;',
    'letter-spacing:.5px;text-transform:uppercase;line-height:21px;',
    'padding:8px 24px;border-radius:4px;white-space:nowrap;',
    'background:rgba(0,0,0,.8);color:#fff;border:0;box-shadow:none}',
    '#mmPro .mmPBadge[hidden]{display:none}',
    /* 17.08. Mert: "mach diesen Rabattprozent irgendwo rein, entweder ins
       Bild irgendwo passend oder neben der Ueberschrift". Er sitzt oben
       LINKS, gegenueber vom Bestseller-Badge, und traegt die Produktfarbe -
       dunkler Text darauf, damit er auf allen zehn Farben lesbar bleibt
       (schlechtester Wert 4.7 beim Florea-Pinkrot). */
    /* 17.08. Mert: "mach die Rabattanzeige genau hier nicht zu gross und
       sowie diese Zahlanzeige in dem Design." Also raus vom Bild, rein neben
       den Zaehler - und exakt dieselbe Pille: gleiche Groesse, gleicher
       Radius, gleiche gedaempfte Flaeche. Unterschied nur, dass beim Rabatt
       der ganze Text die Produktfarbe traegt. */
    /* 17.08. Mert: "mach das ganz links im Bild und bisschen groesser."
       Pillenform und Produktfarbe wie beim Zaehler, aber eine Stufe groesser
       (.82rem statt .66) und wieder oben links auf dem Bild.
       Der Grund liegt hier auf einem FOTO, nicht auf der dunklen Karte -
       die 14-prozentige Tuenchung waere darauf unlesbar. Deshalb dunkle
       Flaeche mit der Produktfarbe als Schrift: lesbar ueber jedem Motiv,
       und die Farbe wandert trotzdem mit. */
    '#mmPro .mmPRabatt{position:absolute;top:12px;left:12px;z-index:2;',
    'display:inline-flex;align-items:center;padding:6px 13px;',
    'border-radius:999px;background:rgba(21,16,19,.78);',
    'color:var(--pf,' + GRUEN + ');font-size:.82rem;font-weight:700;line-height:1.2;',
    'white-space:nowrap;font-variant-numeric:tabular-nums;',
    'transition:color .45s ease}',
    '#mmPro .mmPRabatt[hidden]{display:none}',

    /* Fuss: Pfeil, Balken, Pfeil */
    /* Bedienzeile: Pfeil, Balken, Pfeil - direkt unter dem Bild. */
    '#mmPro .mmPPunkte{display:flex;align-items:center;gap:12px;margin:12px 0 0}',
    /* 17.08. Mert: "Du hast die Pfeile kreisfoermig gemacht. Mach das wie
       unten die Section, genau so." Werte deshalb eins zu eins aus
       mm-ziel.js (.mmZPfeil) uebernommen: 34x34, Radius 10, kein Rahmen,
       gefuellte Flaeche rgba(243,233,236,.08), Schriftgrad 17. */
    '#mmPro .mmPPfeil{width:34px;height:34px;flex:none;padding:0;border:0;',
    'border-radius:10px;background:rgba(243,233,236,.08);color:#F3E9EC;',
    'font-size:17px;line-height:1;cursor:pointer;display:flex;',
    'align-items:center;justify-content:center;',
    '-webkit-tap-highlight-color:transparent;transition:background .2s ease}',
    '#mmPro .mmPPfeil:hover{background:rgba(243,233,236,.16)}',
    '#mmPro .mmPPfeil[disabled]{opacity:0;pointer-events:none}',
    '#mmPro .mmPZahl[hidden]{display:none}',
    '#mmPro .mmPPfeil:focus-visible{outline:2px solid ' + GRUEN + ';outline-offset:2px}',
    /* Balkenhoehe: erst "dicker" (von 2 px), dann "ein bisschen zu dick"
       (bei 6 px). Jetzt 4 px.
       Der Balken ist am 17.08. dreimal gewandert: erst unter die Reiter,
       dann ueber die Ueberschrift, jetzt "UNTER DEM BILD" - also direkt
       unter dem Motiv und ueber dem Titel, innerhalb der Karte. */
    '#mmPro .mmPSpur{position:relative;display:block;flex:1 1 auto;min-width:60px;',
    'height:4px;margin:0;background:rgba(243,233,236,.12);',
    'border-radius:999px;overflow:hidden}',
    /* Die Fuellung wird ueber transform:scaleX gezogen, nicht ueber width.
       width laesst den Browser bei JEDEM Schritt neu umbrechen; scaleX
       laeuft rein im Compositor. Das ist der Unterschied zwischen ruckeln
       und gleiten, vor allem am Handy. Runde Ecken macht die Spur per
       overflow:hidden - die Fuellung braucht deshalb keine eigenen. */
    '#mmPro .mmPFuell{position:absolute;left:0;top:0;height:100%;width:100%;',
    'display:block;transform:scaleX(0);transform-origin:left center;',
    'background:var(--pf,' + GRUEN + ');',
    'transition:background .45s ease;will-change:transform}',

    /* 17.08. Mert: "auf Computer zeigt er das riesengross an ... ich will das
       genauso wie bei dem", und: "auf Handy soll er genau so anzeigen, wie er
       gerade anzeigt."

       Am Handy aendert sich deshalb NICHTS - die Regel greift erst ab 760 px,
       genau wie in der unteren Sektion. Vorher lief die Karte auf 1440 px in
       einer Spalte: das Bild wurde bei 4/3 und 922 px Breite ganze 692 px
       hoch, die Sektion 1298 px. Jetzt liegen Bild und Bedienung links, der
       Text rechts daneben und mittig - das Bild bleibt damit rund 345 px. */
    '@media (min-width:760px){',
    '#mmPro .mmPBlatt{display:grid;grid-template-columns:1fr 1fr;',
    'column-gap:clamp(14px,2.4vw,26px);align-items:start}',
    '#mmPro .mmPBild{grid-column:1;grid-row:1}',
    '#mmPro .mmPPunkte{grid-column:1;grid-row:2}',
    '#mmPro .mmPText{grid-column:2;grid-row:1 / span 2;align-self:center}',
    '#mmPro .mmPZeile{margin-top:0}}',

    '@media (prefers-reduced-motion:reduce){',
    '#mmPro .mmPBlatt,#mmPro .mmPGleiter{transition:none!important}',
    '#mmPro .mmPBlatt:not(.da){opacity:1;transform:none;filter:none}}'
  ].join('');

  function stil() {
    if (document.getElementById('mmPro-stil')) return;
    var s = document.createElement('style');
    s.id = 'mmPro-stil';
    s.textContent = css;
    (document.head || document.documentElement).appendChild(s);
  }

  /* BADGES (Mert, 16.08.). Sie kommen aus echten Shopify-Daten, nie aus
     einer Liste in diesem Code — sonst stünde irgendwann "Bestseller" an
     einem Produkt, das keiner mehr kauft.

     Reihenfolge der Prüfung:
       1. Produkt-Schlagwort  → du steuerst es selbst im Shopify-Admin.
          Erlaubt sind: Bestseller · Neu · Hot · Vorbestellen
       2. Kollektion "Bestseller"      → Badge "Bestseller"
       3. Kollektion "NEW COLLECTION"  → Badge "Neu"
       4. sonst kein Badge

     "Vorbestellen" habe ich bewusst NICHT automatisch vergeben: am
     16.08. war jedes Produkt der Zunehmen-Kollektion auf Lager, das
     Badge wäre also falsch gewesen. Setz das Schlagwort, sobald es
     wirklich zutrifft. */
  var SCHLAGWORT = {
    'bestseller':   { text: 'Bestseller',   art: 'bestseller' },
    'neu':          { text: 'Neu',          art: 'neu' },
    'hot':          { text: 'Hot',          art: 'ruf' },
    'vorbestellen': { text: 'Vorbestellen', art: 'ruf' }
  };

  function handles(pfad) {
    return fetch(pfad, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var m = {};
        ((j && j.products) || []).forEach(function (p) { m[p.handle] = true; });
        return m;
      })
      .catch(function () { return {}; });
  }

  function badgeFuer(p, top, neu) {
    var treffer = null;
    (p.tags || []).forEach(function (t) {
      var k = SCHLAGWORT[String(t).trim().toLowerCase()];
      if (k && !treffer) treffer = k;
    });
    if (treffer) return treffer;
    if (top[p.handle]) return SCHLAGWORT['bestseller'];
    if (neu[p.handle]) return SCHLAGWORT['neu'];
    return null;
  }

  function holen(pfad, top, neu) {
    return fetch(pfad, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.products) return [];
        return j.products.map(function (p) {
          var b = (p.images || [])[0];
          return {
            titel: p.title,
            text: beschreibung(p),
            rabatt: rabattVon(p),
            geschmack: geschmackVon(p.title),
            ziel: '/products/' + p.handle,
            bild: b ? b.src.replace(/(\.[a-z]+)(\?|$)/i, '_800x$1$2') : '',
            badge: badgeFuer(p, top || {}, neu || {})
          };
        }).filter(function (x) { return x.bild; });
      })
      .catch(function () { return []; });
  }

  function bauen(daten) {
    if (document.getElementById('mmPro')) return true;
    /* 19.08.2026: Mert hat sich fuer diese Fassung entschieden ("tu jetzt
       das hoechste Section in meine Seite rein"). Die alte Fassung
       mm-ziel.js ist damit aus theme.liquid ausgetragen - also darf der
       Anker NICHT mehr #mmZiel sein, das gaebe es dann gar nicht mehr und
       die Sektion wuerde nie gebaut. Anker ist jetzt wieder die
       Kachelreihe #mmHigh, wie es die alte Fassung gemacht hat: dahinter,
       nicht davor (Mert am 16.08.: "aktion highlights da drueber nicht da
       drunter"). */
    var anker = document.getElementById('mmHigh');
    if (!anker) return false;
    stil();

    var sek = document.createElement('section');
    sek.id = 'mmPro';
    sek.innerHTML =
      '<div class="mmPInnen">' +
      '<p class="mmPAuge">Dein Ziel</p>' +
      '<h2>Was passt zu dir?</h2>' +
      '<div class="mmPTrenner"></div>' +
      '<div class="mmPLeiste" role="tablist"><span class="mmPGleiter"></span>' +
      REITER.map(function (r, i) {
        return '<button class="mmPKnopf" role="tab" aria-selected="' + (i === 0) + '">' +
          r.name + '</button>';
      }).join('') +
      '</div>' +
      '<div class="mmPSorten" role="tablist" aria-label="Geschmack"></div>' +
      /* 17.08. Mert: "Ich will, dass diese Pfeiltasten genau da sind" - an
         den beiden Enden des Balkens, direkt unter dem Bild.

         Dafuer ist die Karte jetzt ein <div> mit ZWEI Links darin statt eines
         grossen <a>. Grund: ein <button> darf laut HTML nicht in einem <a>
         stehen (verschachtelte Bedienelemente). Browser zeigen es zwar, aber
         Tastatur und Vorlesehilfen kommen durcheinander. So bleibt alles
         gueltig: oben der Bildlink, dann die Bedienzeile, darunter der
         Textlink - beide zeigen aufs selbe Produkt. */
      '<div class="mmPBuehne">' +
      '<div class="mmPBlatt da">' +
      '<a class="mmPBild" href="#"><span class="mmPBildBox"><img alt="">' +
      '<span class="mmPRabatt" hidden></span>' +
      '<span class="mmPBadge" hidden></span></span></a>' +
      '<div class="mmPPunkte">' +
      '<button type="button" class="mmPPfeil" data-richtung="-1" aria-label="Vorheriges Bild">‹</button>' +
      '<span class="mmPSpur" role="progressbar" aria-valuemin="1">' +
      '<i class="mmPFuell"></i></span>' +
      '<button type="button" class="mmPPfeil" data-richtung="1" aria-label="Nächstes Bild">›</button>' +
      '</div>' +
      '<a class="mmPText" href="#">' +
      '<span class="mmPZeile"><h3></h3>' +
      '<span class="mmPZahl" aria-hidden="true"></span></span>' +
      '<p></p><span class="mmPMehr">Zum Produkt →</span></a>' +
      '</div>' +
      '</div></div>';

    /* Mert 16.08.: "aktion highlights da drüber nicht da drunter" —
       also HINTER die Kachelreihe, nicht davor. */
    anker.parentNode.insertBefore(sek, anker.nextSibling);

    var knoepfe = [].slice.call(sek.querySelectorAll('.mmPKnopf'));
    var gleiter = sek.querySelector('.mmPGleiter');
    var blatt = sek.querySelector('.mmPBlatt');
    var bildLink = blatt.querySelector('.mmPBild');
    var textLink = blatt.querySelector('.mmPText');
    var bild = blatt.querySelector('img');
    var h3 = blatt.querySelector('h3');
    var p = blatt.querySelector('p');
    var punkte = sek.querySelector('.mmPPunkte');
    var spur = sek.querySelector('.mmPSpur');
    var fuell = sek.querySelector('.mmPFuell');
    var zahl = sek.querySelector('.mmPZahl');
    var badge = blatt.querySelector('.mmPBadge');
    var chip = blatt.querySelector('.mmPRabatt');
    var pfeile = [].slice.call(sek.querySelectorAll('.mmPPfeil'));

    var reiter = 0, folie = 0;
    var sorte = null;                 // null = alle Sorten
    var sorten = sek.querySelector('.mmPSorten');

    function gleiterSetzen() {
      var k = knoepfe[reiter];
      if (!k) return;
      gleiter.style.width = k.offsetWidth + 'px';
      gleiter.style.height = k.offsetHeight + 'px';
      gleiter.style.transform = 'translateX(' + k.offsetLeft + 'px)';
    }

    function zeigen(neu) {
      var liste = aktuelleListe();
      if (!liste || !liste.length) return;
      folie = ((neu % liste.length) + liste.length) % liste.length;
      var a = liste[folie];

      /* Sofort, nicht erst nach dem 260-ms-Ausblenden: die Linie muss mit
         DERSELBEN Uhr starten wie takten(), sonst haengt sie je Bild 260 ms
         nach und liegt nach elf Bildern fast drei Sekunden daneben. */
      balkenNeu();

      blatt.classList.remove('da');
      setTimeout(function () {
        bild.src = a.bild;
        bild.alt = a.titel;
        if (a.badge) {
          badge.textContent = a.badge.text;
          badge.setAttribute('data-art', a.badge.art);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
        if (a.rabatt >= 5) {
          chip.textContent = '\u2212' + a.rabatt + ' %';   /* echtes Minuszeichen */
          chip.hidden = false;
        } else {
          chip.hidden = true;
        }
        /* Die Produktfarbe wird HIER gesetzt, nicht schon vor dem
           Ausblenden: sonst springt sie 260 ms zu frueh um und das alte
           Bild steht noch da, waehrend Balken und Zaehler schon die neue
           Farbe tragen. */
        sek.style.setProperty('--pf', produktfarbe(a.titel));
        h3.textContent = a.titel;
        p.textContent = a.text || REITER[reiter].text;
        bildLink.href = a.ziel;
        textLink.href = a.ziel;
        blatt.classList.add('da');
      }, ruhig ? 0 : 260);
    }

    /* Fuellt den Abschnitt des aktuellen Bildes in genau TAKT Millisekunden -
       dieselbe Zahl, mit der takten() weiterschaltet. Beide werden im selben
       Aufruf gestartet, also koennen sie nicht auseinanderlaufen. */
    /* 17.08. Mert: "Bei der Section ganz oben laeuft dieser Balken nicht ganz
       zeitlich durch ... das wird sehr komisch geskippt. Vom Bild zu Bild
       kommt das sehr komisch rueber."

       Ursache waren ZWEI UHREN: ein setInterval(TAKT) hat weitergeschaltet,
       ein CSS-Uebergang ueber TAKT hat den Balken gemalt. setInterval kommt
       regelmaessig zu spaet (und holt den Rueckstand nie auf), der Uebergang
       ist auf die Millisekunde genau. Also stand der Balken am Segmentende
       still, bis der Takt endlich feuerte - und wurde dann per
       transition:none auf den Anfang des naechsten Segments gerissen. Genau
       dieses Stehen-und-Reissen war das "Skippen".

       Jetzt gibt es nur noch EINE Uhr: ein Zeitstempel je Bild, ausgewertet
       in requestAnimationFrame. Die Breite ist eine reine Funktion der
       verstrichenen Zeit - (folie + Anteil) / Anzahl - und waechst deshalb
       ueber den ganzen Durchlauf durch, ohne Sprung von Bild zu Bild. Das
       Weiterschalten passiert an derselben Stelle, an der der Balken das
       Segmentende erreicht; auseinanderlaufen ist damit unmoeglich.

       Nebenwirkung mit erledigt: vorher hat fuell.style.transition die
       CSS-Regel 'transition:background .45s' ueberschrieben, wodurch der
       Farbwechsel hart umsprang. Das Skript fasst transition jetzt gar
       nicht mehr an. */
    var uhrStart = 0;      // Zeitstempel, seit wann das aktuelle Bild steht
    var rafId = 0;

    /* Die eine Stelle, an der die aktuell gezeigte Liste entsteht. Anzeigen,
       Balken und Zaehler fragen alle hier nach - so koennen Filter und
       Zaehlung nicht auseinanderlaufen. Heisst absichtlich nicht "liste":
       innerhalb der Funktionen gibt es lokale Variablen dieses Namens, die
       den Aufruf sonst verschatten wuerden. */
    function aktuelleListe() {
      var alle = daten[reiter] || [];
      if (!sorte) return alle;
      var gefiltert = alle.filter(function (a) { return a.geschmack === sorte; });
      return gefiltert.length ? gefiltert : alle;
    }

    /* Baut die Sortenknoepfe fuer den aktuellen Reiter neu.

       17.08. Mert: "die brauchen Bilder. Man muss es erkennen durch Bilder,
       durch Symbole - bei Erdbeere eine Erdbeere, bei Nuss Nuesse."
       Genommen wird dafuer das ECHTE Produktfoto der jeweiligen Sorte, klein
       und rund. Kein gezeichnetes Symbol und kein Emoji: das Erdbeer-Foto
       zeigt Erdbeeren, das Nuss-Foto Pistazien - naeher am Produkt geht
       nicht, und es passt zur Regel, dass Produktbilder echt sein muessen.
       Die Bildadresse wird auf _80x heruntergesetzt; das 800er-Bild fuer
       eine 22-px-Scheibe zu laden waere Verschwendung. */
    function sortenBauen() {
      var alle = daten[reiter] || [];
      var vorhanden = [];
      alle.forEach(function (a) {
        if (!a.geschmack) return;
        for (var i = 0; i < vorhanden.length; i++) {
          if (vorhanden[i].name === a.geschmack) return;   // schon erfasst
        }
        vorhanden.push({ name: a.geschmack, bild: a.bild || '' });
      });
      if (vorhanden.length < 2) {          // eine Sorte ist keine Wahl
        sorten.innerHTML = '';
        sorten.hidden = true;
        sorte = null;
        return;
      }
      sorten.hidden = false;
      sorte = null;
      sorten.innerHTML =
        '<button type="button" class="mmPSorte" aria-selected="true">' +
        '<span class="mmPSorteText">Alle</span></button>' +
        vorhanden.map(function (g) {
          var klein = g.bild.replace(/_800x/, '_80x');
          return '<button type="button" class="mmPSorte" aria-selected="false">' +
                 /* KEIN loading="lazy": die Scheibchen sind 22 px gross und
                    stehen sofort im Bild. Lazy-Loading haengt an der
                    Sichtbarkeitspruefung des Browsers, und die steht still,
                    solange die Seite als verborgen gilt - am 17.08. gemessen:
                    naturalWidth blieb 0, obwohl die Adresse HTTP 200 lieferte.
                    Eager laden ist hier auch sachlich richtig, es sind ein
                    paar Kilobyte. */
                 (klein ? '<img class="mmPSorteBild" src="' + klein + '" alt="" ' +
                          'decoding="async">' : '') +
                 '<span class="mmPSorteText">' + g.name + '</span></button>';
        }).join('');
    }

    function jetztMs() {
      return (window.performance && performance.now)
        ? performance.now() : Date.now();
    }

    function balkenNeu() {
      var liste = aktuelleListe();
      var n = (liste && liste.length) || 1;
      spur.setAttribute('aria-valuenow', String(folie + 1));
      spur.setAttribute('aria-valuemax', String(n));
      spur.setAttribute('aria-valuetext', 'Bild ' + (folie + 1) + ' von ' + n);
      /* aria-hidden am Element: die Ansage macht die Spur, die sichtbare
         Zahl wuerde sie sonst ein zweites Mal vorlesen. */
      zahl.innerHTML = '<b>' + (folie + 1) + '</b>/' + n;

      /* 17.08. Mert: "wenn nur ein Produkt da ist nach Kategorie ... dann
         soll das nicht laden. Er soll komplett vollgeladen sein, aber nicht
         die ganze Zeit aus und an."
         Bei einer einzigen Karte lief der Balken voll, das Weiterschalten
         landete wieder auf derselben Karte, der Balken sprang auf null und
         fing neu an - dazu blendete die Karte jedes Mal aus und ein. Also:
         Balken voll stehen lassen, Uhr gar nicht starten, Pfeile und Zaehler
         weg, weil es nichts zu blaettern gibt. */
      var einzeln = n <= 1;
      zahl.hidden = einzeln;
      pfeile.forEach(function (k) {
        k.disabled = einzeln;
        k.setAttribute('aria-hidden', String(einzeln));
      });
      if (einzeln) {
        fuell.style.transform = 'scaleX(1)';
        letzterWert = 1;
        if (rafId) { window.cancelAnimationFrame(rafId); rafId = 0; }
        return;
      }

      if (ruhig) {                       // ohne Bewegung: einfach der Stand
        fuell.style.transform = 'scaleX(' + ((folie + 1) / n) + ')';
        return;
      }
      uhrStart = jetztMs();
      if (!rafId) rafId = window.requestAnimationFrame(rahmen);
    }

    /* Ein Schritt der Uhr. Reine Funktion der verstrichenen Zeit - deshalb
       ist es voellig egal, WER sie aufruft und wie oft. Genau das erlaubt die
       zwei Antriebe unten. */
    var letzterWert = -1;

    function schritt() {
      var liste = aktuelleListe();
      var n = (liste && liste.length) || 1;
      if (n <= 1) {                    // eine Karte: voll, und Ruhe
        if (letzterWert !== 1) {
          fuell.style.transform = 'scaleX(1)';
          letzterWert = 1;
        }
        return;
      }
      var anteil = (jetztMs() - uhrStart) / TAKT;
      if (anteil < 0) anteil = 0;
      if (anteil > 1) anteil = 1;
      var wert = (folie + anteil) / n;
      /* Gleiche Stellung nicht zweimal schreiben - rAF und Ersatztakt rufen
         diese Funktion gemeinsam bis zu 85-mal je Sekunde auf. */
      if (Math.abs(wert - letzterWert) > 0.0002) {
        fuell.style.transform = 'scaleX(' + wert + ')';
        letzterWert = wert;
      }
      if (anteil >= 1) zeigen(folie + 1);   // ruft balkenNeu(), stellt die Uhr neu
    }

    /* ZWEI ANTRIEBE auf derselben Uhr:

       1) requestAnimationFrame - malt fluessig, Bild fuer Bild.
       2) setInterval alle 200 ms - laeuft weiter, wenn rAF nicht laeuft.

       Der zweite ist keine Bequemlichkeit, sondern noetig: rAF steht still,
       sobald der Browser die Seite fuer verborgen haelt. In der eingebauten
       Vorschau ist document.hidden DAUERHAFT true - dort bewegte sich nach
       dem Umbau auf reines rAF gar nichts mehr (Mert am 17.08.: "Es laedt
       nicht von alleine"). Doppelt aufgerufen zu werden schadet nicht: nach
       einem Weiterschalten steht uhrStart neu, der zweite Aufrufer sieht
       also Anteil 0 und schaltet nicht noch einmal. */
    function rahmen() {
      rafId = 0;
      schritt();
      rafId = window.requestAnimationFrame(rahmen);
    }

    /* KEIN visibilitychange-Handler mehr. Der hat die Uhr bei jedem Wechsel
       auf null gestellt - und am 17.08. gemessen: die eingebaute Vorschau
       meldet 16 Wechsel in 5 Sekunden. Damit kam keine Standzeit je durch,
       der Balken pendelte und nichts schaltete weiter (Mert: "Es laedt nicht
       von alleine"). Ein Karussell muss im Hintergrund auch gar nicht
       anhalten: die Uhr laeuft absolut weiter, und wer zurueckkommt, sieht
       das dann aktuelle Bild mit passendem Balkenstand.
       Nach langer Abwesenheit schaltet schritt() genau EIN Bild weiter und
       stellt die Uhr auf jetzt - es gibt also kein Nachholgewitter. */

    /* Der Ersatzantrieb laeuft immer mit, auch waehrend rAF steht. */
    if (!ruhig) setInterval(schritt, 40);   /* 25/s statt 5/s - 200 ms ruckelte sichtbar */

    /* Notnagel gegen eine unsichtbare Karte.
       Das Ein- und Ausblenden haengt an einem CSS-Uebergang. Laeuft der
       nicht - eingebaute Vorschau, gedrosselter Hintergrund, alter Browser -
       dann bleibt die Karte auf Deckkraft 0 stehen, obwohl sie laengst
       wieder da sein sollte. Der Inhalt waere schlicht weg, ohne Fehler.
       Diese Wache greift nur in genau dem Fall ein: Klasse 'da' gesetzt,
       aber trotzdem durchsichtig. In einem normalen Browser ist der
       Uebergang nach 420 ms fertig, die Pruefung nach 800 ms sieht also
       immer eine sichtbare Karte und tut nichts. */
    if (!ruhig) setInterval(function () {
      var sichtbarSoll = blatt.classList.contains('da');
      var jetztDeckkraft = parseFloat(getComputedStyle(blatt).opacity);
      if (sichtbarSoll && jetztDeckkraft < 0.05) {
        blatt.style.opacity = '1';
        blatt.style.transform = 'none';
        blatt.style.filter = 'none';
      } else if (!sichtbarSoll && blatt.style.opacity) {
        blatt.style.opacity = '';      // Ausblenden wieder freigeben
        blatt.style.transform = '';
        blatt.style.filter = '';
      }
    }, 800);

    /* Stellt die Uhr des aktuellen Bildes auf null. Wird nach Pfeil und
       Wisch aufgerufen, damit die Standzeit dort frisch beginnt. */
    function takten() {
      if (ruhig) return;
      uhrStart = jetztMs();
      if (!rafId) rafId = window.requestAnimationFrame(rahmen);
    }


    knoepfe.forEach(function (k, i) {
      k.addEventListener('click', function () {
        reiter = i;
        knoepfe.forEach(function (x, j) { x.setAttribute('aria-selected', String(i === j)); });
        sortenBauen();                   // andere Sorten je Reiter
        gleiterSetzen();
        zeigen(0);
        takten();
      });
    });

    /* Sorte waehlen: filtert die Liste des aktuellen Reiters und faengt
       wieder beim ersten Treffer an. */
    sorten.addEventListener('click', function (e) {
      var k = e.target.closest('.mmPSorte');
      if (!k) return;
      e.preventDefault();
      [].forEach.call(sorten.children, function (x) {
        x.setAttribute('aria-selected', String(x === k));
      });
      var name = (k.querySelector('.mmPSorteText') || k).textContent.trim();
      sorte = (name === 'Alle') ? null : name;
      zeigen(0);
      takten();
    });

    /* Pfeile blättern eins vor oder zurück. */
    punkte.addEventListener('click', function (e) {
      var k = e.target.closest('.mmPPfeil');
      if (!k) return;
      e.preventDefault();
      zeigen(folie + parseInt(k.getAttribute('data-richtung'), 10));
      takten();                       // Uhr neu stellen, sonst springt es gleich weiter
    });

    /* Wischen auf der Karte blättert. Heikel: die Karte IST ein Link.
       Deshalb wird die Bewegung gemessen — ab 40 px waagerecht gilt es als
       Wischen, und der darauf folgende Klick wird einmalig geschluckt.
       Sonst würde jeder Wisch die Produktseite öffnen. */
    var startX = 0, startY = 0, wischt = false, geschluckt = false;
    blatt.addEventListener('pointerdown', function (e) {
      startX = e.clientX; startY = e.clientY; wischt = false;
      /* 17.08.: geschluckt MUSS hier zurueck. Ein Wisch setzt es auf true,
         damit der darauf folgende Klick die Produktseite nicht oeffnet - am
         Touchgeraet folgt aber gar kein Klick. Ohne dieses Zuruecksetzen
         blieb der Merker stehen und verschluckte den NAECHSTEN, echten Tipp:
         nach einmal Wischen liess sich das Produkt nicht mehr oeffnen.
         Mert am 17.08.: "Wenn man das Bild drueckt, soll man zum Produkt
         kommen." */
      geschluckt = false;
    }, { passive: true });
    blatt.addEventListener('pointermove', function (e) {
      if (!startX) return;
      var dx = e.clientX - startX, dy = e.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) wischt = true;
    }, { passive: true });
    blatt.addEventListener('pointerup', function (e) {
      if (!wischt) { startX = 0; return; }
      var dx = e.clientX - startX;
      zeigen(folie + (dx < 0 ? 1 : -1));
      takten();
      geschluckt = true;
      startX = 0;
    }, { passive: true });
    blatt.addEventListener('click', function (e) {
      if (geschluckt) { e.preventDefault(); geschluckt = false; }
    });

    sortenBauen();
    gleiterSetzen();
    zeigen(0);
    takten();
    window.addEventListener('resize', gleiterSetzen, { passive: true });
    setTimeout(gleiterSetzen, 600);
    return true;
  }

  function start() {
    Promise.all([
      handles('/collections/bestseller/products.json?limit=30'),
      handles('/collections/new-collection/products.json?limit=30')
    ]).then(function (listen) {
      var top = listen[0], neu = listen[1];
      return Promise.all([
        holen(REITER[0].quelle, top, neu),
        holen(REITER[1].quelle, top, neu)
      ]);
    })
      .then(function (r) {
        // Lieber nichts zeigen als eine Sektion mit leeren Reitern
        if (!r[0].length || !r[1].length) return;
        var daten = [r[0], r[1], REITER[2].bilder];
        if (bauen(daten)) return;
        var n = 0;
        var t = setInterval(function () {
          n++;
          if (bauen(daten) || n > 14) clearInterval(t);
        }, 700);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
